"use strict";

const Navigation = () => {
    const init = () => {
        $(function () {
            $('.js-navbar-toggle').on('click', function() {
                if($('.js-navbar').hasClass('open')){
                    $('.js-navbar').removeClass('open')
                }else{
                    $('.js-navbar').addClass('open')
                }
            });

            $('.js-navbar-filters-toggle').on('click', function() {
                if($('.js-navbar').hasClass('filters-open')){
                    $('.js-navbar').removeClass('filters-open')
                }else{
                    $('.js-navbar').addClass('filters-open')
                }
            });

            $(window).on('scroll', function(){
                if($(this).scrollTop() > 0){
                    $('.js-navbar').addClass('small');
                }else{
                    $('.js-navbar').removeClass('small');
                }
            });
        });
    };
    
    return {
        init: init
    };
};

export default Navigation;